<template>
  <div class="videoBoxContener" v-show="show">
    <div class="xyjVideo">
      <div class="inviteInfoVideo" v-if="status == 0">
        <div>
          <div class="headLogoVideo">
            <img :src="user.img">
          </div>
          <div class="userNameVideo">
            {{user.name}}
          </div>
          <div class="titStatus">
            {{titText}}
          </div>
        </div>
      </div>
      <div class="videoOption">
        <div v-if="!isMuted && status == 1" @click="mutedSound">
          <img src="../../../assets/images/icon_jingyin_weidianji_40px.png" alt="">
          <span>静音</span>
        </div>
        <div v-if="isMuted && status == 1" @click="mutedSound">
          <img src="../../../assets/images/icon_jingyin_dianji_40px.png" alt="">
          <span>静音</span>
        </div>
        <div @click="receiveVideo" v-if="receiveStatus">
          <img src="../../../assets/images/button_jieting_68px.png" alt="">
          <span>接听</span>
        </div>
        <div @click="stopVideo">
          <img src="../../../assets/images/icon_guaduan_40px.png" alt="">
          <span>挂断</span>
        </div>
      </div>
      <video v-show="status == 1" ref="localVideo" :class="[isSelfBigWindow?'bigWindow':'smallWindow']" id="localVideo"
        autoplay playsinline @click="toggleWindow"></video>
      <video v-show="status == 1" ref="remoteVideo" :class="[!isSelfBigWindow?'bigWindow':'smallWindow']" id="remoteVideo"
        autoplay playsinline @click="toggleWindow"></video>
    </div>
    <audio loop src="../../../../static/sound/wxting.mp3" ref="audioEle"></audio>
    <el-dialog v-dialog-drag
               width="60%"
               :append-to-body="true"
               :modal-append-to-body="true"
               :visible.sync="dialogVisibleHelp"
    >
    <div style="font-size: 14px;margin:10px;">
      地址：chrome://flags/#unsafely-treat-insecure-origin-as-secure
    </div>
      <img v-if="jtimg"
           style="width:914px;margin-top:50px"
           src="../../../../static/img/help.png"
           alt=""
      >
      <img v-else
           style="width:914px;margin-top:50px"
           src="../../../../static/img/help.gif"
           alt=""
      >
      <span slot="footer"
            class="dialog-footer"
      >
        <el-button @click="jtimg = true">取消动画</el-button>
        <el-button type="primary"
                   @click="jtimg = false"
        >查看动画</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import videoChat from "./videoMqtt.js";
export default {
  name: "videoComponent",
  props: {
    // 对方的用户信息
    chatid: {
      type: String,
      default: "",
    },
  },
  watch: {
    chatid: {
      handler: function (val) {
        
        if (this.show) {
          console.error("当前正处于聊天状态");
          return;
        }
        if (!val) {
          return;
        }
        // 初次要展示用户信息头像
        this.status = 0;
        // 代表呼叫方
        this.isCalled = false;
        // 提示文字
        this.titText = "正在等待对方接受邀请...";
        // 接听按钮要隐藏掉初次视频聊天的时候
        this.receiveStatus = false;
        // 视频窗口显示出来
        this.show = true;
        this.getUserInfo(val);
      },
      deep: true
    },
  },
  data() {
    return {
      dialogVisibleHelp: false, // 弹框状态
      jtimg: true, // 弹框动画状态
      isMuted: false, // 是否静音
      user: {
        // 自己的信息
        img: "",
        name: "",
        id: "",
      },
      show: false, // 显示聊天的弹框
      status: 0, // 当前的状态 0代表等待接受邀请 1代表通话中
      isSelfBigWindow: false, // 是否是自己的window窗口
      messageEvent: "", // 消息事件
      inviteInfo: {}, // 呼叫方的信息
      time: null, // 时间
      isCalled: false, // 是否是被呼叫方
      titText: "", // 提示文字
      receiveStatus: false, // 是否显示接收按钮
      a: 1,
    };
  },
  mounted() {
    const adapter = require("webrtc-adapter"); // 不能删除有用的东西 不许删除否则会黑屏
    this.$bus.$on("videoCallback", this.callback);
    this.getSelfInfo();
    window.openDialogVisibleHelp = () => {
      this.dialogVisibleHelp = true;
      try { // 关闭聊天窗口 因为有可能获取不到就加try了
        if (this.jquery("#chart").css("display") != 'none') {
          this.$parent.$parent.$parent.chat = false;
        }
      } catch (error) {
        //
      }
      this.cancle(); // 取消
    };
  },
  methods: {
    // 获取用户信息
    getUserInfo(id, notInitVideo) {
      let query = {
        querys: [
          {
            hasInitValue: false,
            operation: "EQUAL",
            property: "id",
            relation: "AND",
            value: id,
          },
        ],
      };
      this.$api.im
        .userQuery(query)
        .then((res) => {
          if (res.data.rows && res.data.rows.length > 0) {
            this.user.id = res.data.rows[0].id;
            this.user.img = res.data.rows[0].headportrait;
            this.user.name = res.data.rows[0].usernickname;
            if (notInitVideo) {
              // 被呼叫方获取自己的信息
              return;
            }
            this.videoInit();
          }
        })
        .catch((err) => {
          if (String(err.message).indexOf("getUserMedia") != -1) {
            window.openDialogVisibleHelp();
            return;
          }
          this.$message.error(err.message);
        });
    },
    videoInit() {
      var options = {
        touserID: this.user.id, // 被呼叫用户chatid,
        tousername: this.user.name, // 被呼叫用户名,
        touserLogo: this.user.img, // 对方头像
        selfId: this.inviteInfo.id, // 呼叫方的chatid
        selfName: this.inviteInfo.name, // 呼叫方的名称
        selfLogo: this.inviteInfo.img, // 呼叫方头像
        vueThis: this, // 当前vue的实例
        audioOnly: false, // 是否仅音频，false为视频，true为音频
      };
      if (!this.inviteInfo.id || !this.user.id) {
        this.$message.error("用户信息不存在，请退出重试。");
        return;
      }
      // 60s之后没有人接自动挂断
      this.autoClose();
      window.VideoChatEle = new videoChat(options, this.callback);
    },
    autoClose(){
      var n = 0;
      this.time = setInterval(() => {
        n++;
        if (n >= 60) {
          clearInterval(this.time);
          this.cancle(); // 取消
        }
      }, 1000);
    },
    callback(msg) {
      if (msg.showVideo) { // 显示视频
        this.status = 1;
        this.show = true;
        if (this.$refs.audioEle){
          this.$refs.audioEle.pause();
          this.$refs.audioEle.currentTime = 0;
        }
        return;
      }
      if (msg.close) { // 挂断
        setTimeout(() => {
          this.show = false;
          this.status = 0;
          this.clearData();
        },1);
        return;
      }
      if (msg.receivedOnOtherDevices) { // 已在其他端建立连接
        this.titText = "已从其它设备通话";
        setTimeout(() => {
          this.show = false;
          this.status = 0;
          this.clearData();
        },1000);
        return;
      }
      if (msg.soundOpen) {
        this.$nextTick(() => {
          this.$refs.audioEle && this.$refs.audioEle.play();
        })
        return;
      }
      // 呼叫方视频聊天的时候就获取了对方的信息 所以只有被呼叫方没有对方的信息 这里用user.id判断是否是呼叫方
      if (!this.user.id && (msg.eventName == "__invite" || msg.eventName == "__inviteRing")) {
         // 初次要展示用户信息头像
        this.status = 0;
        // 被呼叫方
        this.isCalled = true;
        // 提示文字
        this.titText = "正在邀请您接收对方视频电话...";
        this.show = true;
        this.$nextTick(() => {
          this.$refs.audioEle && this.$refs.audioEle.play();
        })
        // 接听方无人接听 70秒之后自动关闭
        var n = 0;
        this.time = setInterval(() => {
          n++;
          if (n >= 70) {
            clearInterval(this.time);
             this.show = false;
          }
        }, 1000);
        this.getUserInfo(msg.messageString.inviteID, true);
      }
      if (msg.eventName != "__invite" && msg.eventName != "__inviteRing") {
        clearInterval(this.time); // 清除60秒自动取消视频聊天的功能
      }
      this.messageEvent = msg.eventName;
      if (this.messageEvent == '__invite') {
        this.receiveStatus = true;
      }
    },
    cancle() {
      var room = this.getRoomDataByInviteID();
      window.videoChatCallback({
        event: "__cancel",
        userId: this.user.id,
        fromID: this.inviteInfo.id,
        room: room,
        data: {
          userList: this.user.id,
          inviteID: this.inviteInfo.id,
          room: room,
        },
      });
      this.show = false;
      this.clearData();
    },
    // 获取呼叫方的信息
    getSelfInfo() {
      let query = {
        querys: [
          {
            hasInitValue: false,
            operation: "EQUAL",
            property: "id",
            relation: "AND",
            value: sessionStorage.getItem("chatid"),
          },
        ],
      };
      this.$api.im
        .userQuery(query)
        .then((res) => {
          if (res.data.rows && res.data.rows.length > 0) {
            this.inviteInfo.id = res.data.rows[0].id;
            this.inviteInfo.img = res.data.rows[0].headportrait;
            this.inviteInfo.name = res.data.rows[0].usernickname;
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 静音
    mutedSound() {
      this.isMuted = !this.isMuted;
      console.log(videoChat);
      videoChat.muted(this.isMuted);
    },
    // 切换窗口大小
    toggleWindow() {
      this.isSelfBigWindow = !this.isSelfBigWindow;
    },
    // 根据InviteID获取房间信息
    getRoomDataByInviteID() {
      var inviteID = !this.isCalled ? this.inviteInfo.id : this.user.id;
      var roomInfo = JSON.parse(localStorage.getItem("roomInfo"));
      for (const key in roomInfo) {
        if (roomInfo[key].inviteID == inviteID) {
          return key;
        }
      }
    },
    // 接收视频邀请
    receiveVideo() {
      var room = this.getRoomDataByInviteID();
      window.videoChatCallback({
        event: "__join",
        userId: this.user.id,
        data: {
          fromID: this.inviteInfo.id,
          userId: this.user.id,
          room: room,
        },
        room: room,
      });
      this.status = 1;
      this.receiveStatus = false;
      if (this.$refs.audioEle){
          this.$refs.audioEle.pause();
          this.$refs.audioEle.currentTime = 0;
        }
    },
    // 挂断
    stopVideo() {
      if (this.titText == "已从其它设备通话") {
        return;
      }
      this.show = false;
      var room = this.getRoomDataByInviteID();
      clearInterval(this.time);
      if (this.messageEvent == "__invite") {
        // 被呼叫方收到邀请
        window.videoChatCallback({
          event: "__reject",
          data: {
            fromID: this.inviteInfo.id,
            userId: this.user.id,
            room: room,
            refuseType: 1, // 0忙线 1挂断
          },
          room: room,
          userId: this.user.id,
        });
      }
      if (this.messageEvent == "__inviteRing") {
        // 呼叫方收到响应
        this.cancle();
      }
      if (this.messageEvent == "__ice_candidate") {
        window.videoChatCallback({
          event: "__leave",
          fromID: this.inviteInfo.id,
          userId: this.user.id,
          room: room,
          data: {
            fromID: this.inviteInfo.id,
            room: room,
            userId: this.user.id,
          },
        });
      }
      this.clearData();
    },
    clearData(){
      localStorage.removeItem("roomInfo"); // 清除房间信息
      if (this.$refs.audioEle){
        this.$refs.audioEle.pause();
        this.$refs.audioEle.currentTime = 0;
      }
      window.VideoChatEle = null;
      this.user = { img: "", name: "", id: "" };
      this.$emit("videoCallback");
      videoChat.close();
    }
  },
};
</script>
<style scoped>
.videoBoxContener {
  display: block;
}
.xyjVideo {
  position: absolute;
  right: -358px;
  width: 350px;
  height: 100%;
  background: rgb(0, 0, 0);
  user-select: none;
}
.inviteInfoVideo {
}
.headLogoVideo img {
  width: 100px;
  height: 100px;
  border-radius: 6px;
  display: block;
  margin: 0 auto;
  margin-top: 160px;
}
.userNameVideo {
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
  color: #ffffff;
  margin: 20px 0;
  text-align: center;
}
.titStatus {
  font-size: 14px;
  font-weight: 300;
  line-height: 1;
  color: #ffffff;
  opacity: 0.8;
  text-align: center;
}
.bigWindow {
  width: 100%;
  height: 100%;
}
.smallWindow {
  position: absolute;
  z-index: 10;
  top: 30px;
  right: 10px;
  width: 80px;
  height: 130px;
  background: #999;
}
.videoOption {
  position: absolute;
  z-index: 10;
  width: 100%;
  bottom: 80px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.videoOption > div {
  width: 40px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  font-size: 12px;
  color: white;
  cursor: pointer;
}
.videoOption img {
  margin-bottom: 10px;
  width: 40px;
  vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// src/components/vueChart/video/video.vue